import { LitElement, css, html } from 'lit'

export class DzStopEvent extends LitElement {
    static get properties() {
        return {
            event: { type: String },
        }
    }

    connectedCallback() {
        super.connectedCallback()
        this.addEventListener(this.event, (evt) => {
            evt.stopPropagation()
            evt.preventDefault()
        })
    }

}

window.customElements.define('dz-stop-event', DzStopEvent)